export default __webpack_public_path__ + "static/media/640_dummy-2014-store03-mobile-de.7cf6ed9f.png";